// Ekran 07 — Besleme API istemcisi.

import { api } from '../../lib/api'

export type BeslemeDurumu = 'taslak' | 'kaydedildi'
export type EtkinKaynak = 'analiz' | 'tesis' | 'lit'
export type Bant = 'saglikli' | 'izle' | 'kritik' | 'yok'

export type MenuKalemi = {
  id: string
  havuzId: string
  cariUnvan: string
  stokKod: string
  stokAd: string
  miktarT: number
  etkinKm: number | null
  etkinOkm: number | null
  kaynakTipi: EtkinKaynak | null
  /** Plan kaleminde null (K27). */
  bakiye: number | null
  /** bakiye − miktar; eksiye düşerse kırmızı. */
  kalan: number | null
  planMi: boolean
  hij: boolean
  /** K13: kaynak rozetinin tooltip'i — "3 analiz · son NUM-0187 · 14.08 · KM 32,2". */
  kaynakNotu: string
}

/** K10 seçicisinin bir satırı; "Tüm çürütücüler" id'siz gelir. */
export type HedefSecenek = { id: string | null; ad: string; hacim: number }

export type MenuDto = {
  id: string
  belgeNo: string
  tarih: string
  durum: BeslemeDurumu
  hedefCurutucuId: string | null
  hedefCurutucuKod: string | null
  vHedef: number
  hedefler: HedefSecenek[]
  kalemler: MenuKalemi[]
}

export type RaporKalemi = {
  cariUnvan: string
  stokKod: string
  stokAd: string
  miktarT: number
  etkinKm: number | null
  okm: number | null
  biyogaz: number | null
  metan: number | null
  metanKaynagi: 'bmp' | 'ch4' | null
  /** BMP (Nm³/t oKM) ya da CH₄ oranı (%) — hangisi kullanıldıysa. */
  metanKaynakDegeri: number | null
  elektrik: number | null
  okmPayi: number | null
  kaynakTipi: EtkinKaynak | null
  planMi: boolean
}

/** Gün seçicisinin bir satırı. */
export type GunOzeti = { tarih: string; durum: BeslemeDurumu; var: boolean }

export type Gosterge = {
  ad: string
  deger: number | null
  birim: string | null
  hedef: string
  bant: Bant
  etiket: string
}

export type UyariDto = { bant: 'amber' | 'red'; mesaj: string; kuralRef: string }

export type RaporDto = {
  tarih: string
  belgeNo: string
  durum: BeslemeDurumu
  vHedef: number
  toplamT: number
  kmToplam: number | null
  okmToplam: number | null
  kmMix: number | null
  biyogaz: number | null
  metan: number | null
  elektrik: number | null
  isi: number | null
  ch4Ortalama: number | null
  olr: number | null
  bozunmaOlr: number | null
  /** §6.2 formülü — yoğunluk düzeltmeli. */
  hrtHacimsel: number | null
  /** V/Σt — §6.4'ün "84 gün" değeri. */
  hrtKutlesel: number | null
  hacim: number | null
  yogunlukMix: number | null
  cnOrani: number | null
  nYuku: number | null
  nh4Yuku: number | null
  pYuku: number | null
  kYuku: number | null
  sYuku: number | null
  tan: number | null
  fan: number | null
  /** FAN hesabında kullanılan çürütücü pH'ı (K21). */
  curutucuPh: number | null
  h2sPpm: number | null
  h2sKg: number | null
  aktifKarbonKg: number | null
  isitmaIhtiyaciKwh: number | null
  gazKutle: number | null
  dijestat: number | null
  dijestatKm: number | null
  dijestatOkm: number | null
  gubreDegeriTl: number | null
  bozunmaAgirlikli: number | null
  ligninAgirlikli: number | null
  /** Ölçülmüş BMP taşıyan kalem sayısı (K31). */
  bmpliKalem: number
  kalemler: RaporKalemi[]
  gostergeler: Gosterge[]
  uyarilar: UyariDto[]
  varsayimlar: string[]
}

export type KaydetSonucu = {
  belgeNo: string
  hareketSayisi: number
  planKalemi: number
  toplamT: number
  mesaj: string
}

export const besleme = {
  /** Gün seçicisi — menü YARATMAZ, olmayan gün "taslak" döner. */
  gunler: (bitis: string, gun = 7) =>
    api<GunOzeti[]>(`/api/besleme/gunler?bitis=${bitis}&gun=${gun}`),

  menu: (tarih: string) => api<MenuDto>(`/api/besleme/${tarih}`),

  rapor: (tarih: string) => api<RaporDto>(`/api/besleme/${tarih}/rapor`),

  kalemler: (
    tarih: string,
    govde: { hedefCurutucuId: string | null; kalemler: { havuzId: string; miktarT: number }[] },
  ) => api<MenuDto>(`/api/besleme/${tarih}/kalemler`, { yontem: 'PUT', govde }),

  kaydet: (tarih: string) =>
    api<KaydetSonucu>(`/api/besleme/${tarih}/kaydet`, { yontem: 'POST' }),
}
